// Work › Automations at `/c/{slug}/work/automations` (Parity P5; hybrid design §6.1): the rules
// of the company (or one board's, `?board=`), the builder and Describe it. The work sidebar's
// footer links here (sidebars/work.tsx).
import { createRoute, useNavigate } from "@tanstack/react-router";
import { AutomationsScreen } from "../features/automations/automations-screen";
import { useCompany } from "../features/use-feature";
import { workRoute } from "./c.$slug.work";

const ID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const workAutomationsRoute = createRoute({
  getParentRoute: () => workRoute,
  path: "automations",
  validateSearch: (search: Record<string, unknown>) =>
    typeof search.board === "string" && ID.test(search.board) ? { board: search.board } : {},
  component: function WorkAutomations() {
    const { api } = workAutomationsRoute.useRouteContext();
    const { board } = workAutomationsRoute.useSearch() as { board?: string };
    const navigate = useNavigate();
    return (
      <AutomationsScreen
        api={api}
        company={useCompany()}
        boardId={board}
        onBoard={(id) =>
          void navigate({
            to: ".",
            search: (prev: Record<string, unknown>) => {
              const { board: _drop, ...rest } = prev;
              return id ? { ...rest, board: id } : rest;
            },
          } as never)
        }
      />
    );
  },
});
